import React from 'react'
import "../articles.css"
import calculator from "../../../../assets/images/articles/calculator.jpg"
import { Byline, Published } from "../.."

export default function Article12Doc() {
  return (
    <div className='emas__articles'>
    <div className='emas__articles-container'>
        <img className="emas__articles-container_headImage" src={calculator} alt="calculator"/>
        <div className='emas__articles-container_photo'>
          <i >Photo by Pixabay: https://www.pexels.com/photo/couple-people-woman-hand-6963017/</i>
        </div>
        <h1>Home Energy Calculator</h1>
        <div className='emas__articles-container_publish'>
          <p></p>
        </div>
        <div className='emas__articles-container_body'>
            <p>December 2025</p>
            <p>We are pleased to announce that residential electricity customers can now access our free <a href = "/Solar" > home energy calculator.</a></p>
            <p>The calculator estimates your electricity costs from adding solar panels, a battery or an electric vehicle. It can help you work out the size of solar and/or battery that will minimise your electricity costs. It will also help you work out what tariff plan is best for you.</p>
            <p>All you need to do is download your electricity usage (on a half-hourly basis) from your Synergy account and upload it into the calculator.</p>
            <p>In the input sheet, you can enter the costs of solar panels and batteries based on quotes you have received. Alternatively, you can use our default values, which are based on the average costs estimated by CSIRO (after the government rebates have been deducted).</p>
            <p>We also have a paid version of the calculator, accessible from the main calculator page, that includes our electricity price forecasts based on our understanding of where generation, network and retail costs are likely to go in future. </p>
        </div>
        <Published />
    </div>
</div>
  )
}
